import React, { useEffect, useState } from "react";
import axios from "axios";

import MonthWisePWITOHOReport from "./TableView/MonthWisePWITOHOReport";
import MonthWisePWILoadedEmptyReport from "./TableView/MonthWisePWILoadedEmptyReport";
import MonthWisePWIIntNIntReport from "./TableView/MonthWisePWIIntNIntReport";
import DateWisePWITOHOReport from "./TableView/DateWisePWITOHOReport";

const PointWiseInterchangeMaster = () => {
  const [active, setActive] = useState("T/O & H/O");
  const [loading, setLoading] = useState(false);
  const [PWIdata, setPWIdata] = useState([]);
  const [error, setError] = useState(false);
  const [prevPWIdata, setPrevPWIdata] = useState([]);
  const [currPWIdata, setCurrPWIdata] = useState([]);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const a = new Date().getFullYear();
  const b = `${a}-${a + 1}`;
  const [selectedFy, setSelectedFy] = useState(b);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}getPointwiseInterchabge?FyYear=${selectedFy}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setPWIdata(response.data);
          setPrevPWIdata(response.data[0].children);
          setCurrPWIdata(response.data[1].children);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  const fyYearsObj = PWIdata.find((item) => item.fin_yr);
  const fyYears = fyYearsObj?.fin_yr?.slice(1) || [];
  return (
    <div className="">
      <div class="d-flex justify-content-end ">
        <select
          className="form-select text-black fw-bolder text-center form-control w-25"
          onChange={(e) => {
            setSelectedFy(e.target.value);
          }}
          value={selectedFy}
        >
          <option value="" hidden>
            Select Financial Year
          </option>
          {fyYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div className="row ">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("T/O & H/O");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "T/O & H/O" && "active"
            }`}
          >
            T/O & H/O
          </button>
          <button
            onClick={() => {
              setActive("LOADED & EMPTY");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "LOADED & EMPTY" && "active"
            }`}
          >
            LOADED & EMPTY
          </button>
          <hr />
          <button
            onClick={() => {
              setActive("INT & N-INT");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "INT & N-INT" && "active"
            }`}
          >
            INT & N-INT
          </button>{" "}
          <button
            onClick={() => {
              setActive("DATE WISE REPORT");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "DATE WISE REPORT" && "active"
            }`}
          >
            DATE WISE REPORT
          </button>
        </div>
      </div>
      <div className="row">
        {active === "T/O & H/O" ? (
          <div className="">
            <MonthWisePWITOHOReport
              PWIdata={PWIdata}
              prevPWIdata={prevPWIdata}
              currPWIdata={currPWIdata}
              selectedFy={selectedFy}
            />
          </div>
        ) : active === "LOADED & EMPTY" ? (
          <div>
            <MonthWisePWILoadedEmptyReport
              PWIdata={PWIdata}
              prevPWIdata={prevPWIdata}
              currPWIdata={currPWIdata}
              selectedFy={selectedFy}
            />
          </div>
        ) : active === "INT & N-INT" ? (
          <div>
            <MonthWisePWIIntNIntReport
              PWIdata={PWIdata}
              prevPWIdata={prevPWIdata}
              currPWIdata={currPWIdata}
              selectedFy={selectedFy}
            />
          </div>
        ) : (
          <div>
            <DateWisePWITOHOReport
              PWIdata={PWIdata}
              prevPWIdata={prevPWIdata}
              currPWIdata={currPWIdata}
              selectedFy={selectedFy}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default PointWiseInterchangeMaster;
